module.exports = __webpack_public_path__ + "img/HearRo_white_shield_only.1849911a.svg";